import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ProductSection } from './components/ProductSection';
import { PricingSection } from './components/PricingSection';
import { UpsellSection } from './components/UpsellSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { CostComparisonSection } from './components/CostComparisonSection';
import { FinalCtaSection } from './components/FinalCtaSection';
export function App() {
  return <div className="min-h-screen bg-miel-darkest font-inter text-miel-cream selection:bg-miel-crimson selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <ProductSection data-id="element-3" />
      <PricingSection data-id="element-4" />
      <UpsellSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <GuaranteeSection data-id="element-7" />
      <FaqSection data-id="element-8" />
      <CostComparisonSection data-id="element-9" />
      <FinalCtaSection data-id="element-10" />
    </div>;
}